export default "__VITE_ASSET__q6I8xMpl__"